import React from 'react'
import SignIn from '../SignIn'
import enhance from './enhancers'

export function AuthenticatedRoute({ authenticated, children }) {
  return authenticated ? <div>{children}</div> : <SignIn />
}

export default enhance(AuthenticatedRoute)



// WEBPACK FOOTER //
// ./client/modules/user/components/AuthenticatedRoute/index.js